import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CommonMethodService } from "../../Services/CommonMethodService";
import { IBSAdonisService } from "../../Services/IBSAdonisService";
import LoaderCommon from "../../Loader/LoaderCommon";
import { IBodyshopService } from "../../UserService";
import { AdminChecklistItems } from "../../CommonProps";
import { Mixpanel } from "../../Services/MixPanel";

const logout = require("../../../src/assets/images/logout.png").default;
const welcomeSvg =
  require("../../../src/assets/images/svg/welcome.svg").default;
const bookingSvg =
  require("../../../src/assets/images/svg/booking.svg").default;
const trackerSvg =
  require("../../../src/assets/images/svg/tracker.svg").default;

const WelcomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [hasArrivalDates, setHasArrivalDates] = useState<boolean>(true);
  const commonMethodService = new CommonMethodService();
  const ibsAdonisService = new IBSAdonisService();
  const iBodyShop = new IBodyshopService();

  const handleLogout = () => {
    iBodyShop.logout();
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const estimateResponse: any =
          await ibsAdonisService.getJobEstimateDetailsById(params.id as string);
        const estimateDetails = estimateResponse;
        commonMethodService.setDataIntoStorage("estimateData", estimateDetails)
        Mixpanel.track("Entered Welcome Flow", {
          userId: estimateDetails.userId || "unknown",
          estimateId: params.id,
          userName: estimateDetails.userName || "Guest",
          bookingFlowStatus: estimateDetails.isCancelled ? "Cancelled" : "Active",
        });

        // If the booking flow is complete or a booking inspection exists, the user must navigate to the booking inspection screen. They cannot restart the welcome flow.
        const recordExist = await ibsAdonisService.fetchInspectionData(
          `${estimateDetails?.estimateNumber}`
        );
        if (recordExist) {
          navigate(`/?estimateid=${params.id}&step=booking-inspection`);
        }
        const isOnBoardingFlow = estimateDetails.adminCheckList.some(
          (checklistItem: string) =>
            checklistItem.includes(AdminChecklistItems.ONBOARDING_FLOW)
        );
        const isBookingFlow = estimateDetails.adminCheckList.some(
          (checklistItem: string) =>
            checklistItem.includes(AdminChecklistItems.BOOKING_FLOW)
        );
        if (
          isOnBoardingFlow &&
          !isBookingFlow &&
          !estimateDetails.isCancelled
        ) {
          setHasArrivalDates(false);
        } else if (isBookingFlow && !estimateDetails.isCancelled) {
          commonMethodService.removeAllQueryParams();
          commonMethodService.setQueryParams(
            estimateDetails.estimateNumber,
            "booking"
          );
          const parameters = CommonMethodService.params();
          const newQueryParams = new URLSearchParams(parameters);
          navigate(`/?${newQueryParams.toString()}`, { replace: true });
        } else {
          commonMethodService.removeAllQueryParams();
          commonMethodService.setQueryParams(
            estimateDetails.estimateNumber,
            "home"
          );
          const parameters = CommonMethodService.params();
          const newQueryParams = new URLSearchParams(parameters);
          navigate(`/?${newQueryParams.toString()}`, { replace: true });
        }
      } catch (error) {
        console.error("error: ", error);
        navigate("/", { replace: true });
      }
    };

    fetchData();
  }, [params.id, navigate]);

  const handleNavigate = () => {
    const currentParams = new URLSearchParams(location.search);
    currentParams.set("formStep", "1");
    navigate({
      pathname: `/${params.id}/assessment`,
      search: currentParams.toString(),
    });
  };

  return (
    <>
      {!hasArrivalDates ? (
        <div className="welcome-main">
          <div className="welcome-container">
            <div className="logout-icon">
              <img src={logout} onClick={handleLogout} alt="Logout button" />
            </div>
            <div>
              <p className="welcome-heading">Welcome to Our Customer Portal</p>
              <p className="welcome-text">
                We're thrilled to have you here. This portal is your <br />{" "}
                gateway to a seamless and efficient experience with <br /> our
                products and services.
              </p>
            </div>
            <img src={welcomeSvg} className="welcome-img" alt="Welcome Image" />
            <div className="tab-main">
              <div className="tab">
                <img
                  src={bookingSvg}
                  className="booking-img"
                  alt="Booking icon"
                />
                <div className="text-main">
                  <p className="tab-label">Booking Estimate</p>
                  <p className="tab-info">
                    Book, modify, or see your onsite or digital assessment
                    schedule
                  </p>
                </div>
              </div>
              <div className="tab">
                <img
                  src={trackerSvg}
                  className="tracker-img"
                  alt="Booking icon"
                />
                <div className="text-main">
                  <p className="tab-label">Repair Tracker</p>
                  <p className="tab-info">
                    Stay updated and check which stage of the repair your car is
                    at
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="btn-container">
            <button onClick={handleNavigate} className="button-dark">
              Next
            </button>
          </div>
        </div>
      ) : (
        <LoaderCommon isLoginLoader={false} loadingText="" />
      )}
    </>
  );
};

export default WelcomePage;
